import { useEffect } from 'react';
import { Lightbulb } from 'lucide-react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

/** Po přechodu na jinou routu odscrolluje nahoru. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <header className="sticky top-0 z-30 border-b border-line bg-paper/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
          <Link to="/" className="flex items-center gap-2.5" aria-label="Kabinet nápadů, domů">
            <span className="board grid h-9 w-9 place-items-center rounded-[11px]">
              <Lightbulb className="h-5 w-5 text-accent" strokeWidth={2} />
            </span>
            <span className="font-serif text-xl tracking-tight">Kabinet nápadů</span>
          </Link>
          <nav
            className="flex items-center gap-5 text-sm font-medium sm:gap-7"
            aria-label="Hlavní navigace"
          >
            {[
              { to: '/', label: 'Materiály', end: true },
              { to: '/o-nas', label: 'O nás', end: false },
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `focus-ring relative rounded py-1.5 ${isActive ? 'text-ink' : 'text-ink-soft hover:text-ink'}`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <span
                        className="absolute -bottom-0.5 left-0 h-0.5 w-full rounded bg-accent"
                        aria-hidden="true"
                      />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="board mt-16 text-chalk">
        <div className="mx-auto max-w-6xl px-4 py-8 text-sm">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span className="flex items-center gap-2.5">
              <Lightbulb className="h-[18px] w-[18px] text-accent" strokeWidth={2} />
              Kabinet nápadů, materiály od učitelky matematiky a&nbsp;fyziky.
            </span>
            <a
              href="mailto:pf.kabinet.napadu@gmail.com"
              className="focus-ring-chalk rounded text-chalk/80 hover:text-chalk"
            >
              pf.kabinet.napadu@gmail.com
            </a>
          </div>
          <nav
            className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-chalk/15 pt-5 text-chalk/80"
            aria-label="Odkazy v patičce"
          >
            <Link to="/o-nas" className="focus-ring-chalk rounded hover:text-chalk">
              O nás
            </Link>
            <Link to="/obchodni-podminky" className="focus-ring-chalk rounded hover:text-chalk">
              Obchodní podmínky
            </Link>
            <Link to="/odstoupeni-od-smlouvy" className="focus-ring-chalk rounded hover:text-chalk">
              Odstoupení od smlouvy
            </Link>
            <Link to="/reklamacni-rad" className="focus-ring-chalk rounded hover:text-chalk">
              Reklamační řád
            </Link>
            <Link
              to="/ochrana-osobnich-udaju"
              className="focus-ring-chalk rounded hover:text-chalk"
            >
              Ochrana osobních údajů
            </Link>
            <span className="text-chalk/60">© 2026 Kabinet nápadů</span>
          </nav>
        </div>
      </footer>
    </div>
  );
}
